











import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';
import { DynPageDto } from '@/api';
import BlocksDispatcher from '@/views/cms/BlocksDispatcher.vue';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import ErrorKey from '@/util/ErrorKey';
import { TranslateResult } from 'vue-i18n';
import { EventKey } from '@/util/EventKey';
import { ErrorStore } from '@/stores/error.store';
import Routes from '@/util/Routes';
import { Route } from 'vue-router';
import UserStore from '@/stores/user/user.store';

@Component({
  components: {LoadingIndicator, BlocksDispatcher},
})
export default class DynamicPage extends Vue {
  @Prop({required: true})
  public readonly webrootPath!: string;

  public page: DynPageDto | null = null;
  public loading = true;
  public error = false;
  private cmsStore = getModule(CmsStore, this.$store);
  private errorStore = getModule(ErrorStore, this.$store);
  private userStore = getModule(UserStore, this.$store);

  public get genericErrorMessage(): TranslateResult {
    return this.$t('message.cms.dynPageError');
  }

  public async mounted(): Promise<void> {
    if (this.userStore.languageExplicitlySet) {
      this.fetchInLanguage(this.userStore.currentLanguage);
    } else {
      this.$events.$once(EventKey.INITIAL_LANGUAGE, this.fetchInLanguage);
    }
    this.$events.$on(EventKey.LANGUAGE_CHANGE, this.fetchInLanguage);
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    // Component is not re-mounted when only params change (e.g. URL)
    // ref: https://router.vuejs.org/guide/advanced/navigation-guards.html#navigation-guards
    this.fetchInLanguage(this.userStore.currentLanguage, to.params.webrootPath);
    next();
  }

  private async fetchInLanguage(language: string, pathOverride?: string): Promise<void> {
    this.loading = true;
    const webrootPath = '/' + (pathOverride ?? this.webrootPath);
    const pageResponse = await this.cmsStore.fetchDynamicPage({webrootPath, language});
    if (pageResponse.success) {
      this.page = pageResponse.payload ?? null;
    } else if (pageResponse.error?.errorKey === ErrorKey.CmsNotFoundException) {
      this.errorStore.dismissResponseError(pageResponse);
      await this.$router.replace({name: Routes.NotFound});
    } else {
      this.error = true;
    }
    this.loading = false;
  }
}
